import React, { useEffect, useState } from 'react';
import axios from 'axios';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import numberToWords from "number-to-words";
import Qr from '../images/qr.png'
import { useLocation } from "react-router-dom";

const InvoicePage = () => {
  
  const [input, setInput] = useState("");
  const [discount, setDiscount] = useState(0);
  const [selectedButton, setSelectedButton] = useState("");
  
  const[invoiceData,setInvoiceData]=useState([]);
  const[clientData,setClientData]=useState([]);
  const[orderItems,setOrderItems]=useState([]);
  const location = useLocation();
  const { orderId } = location.state || {}
  console.log(invoiceData);
  console.log("client",clientData);
  console.log("orders",orderItems);
  console.log(orderId);



  const handleInputChange = (event) => {
    setInput(event.target.value);
  };

  const handleButtonClick = (buttonType) => {
    setSelectedButton(buttonType);
  };

  const getInvoice = async () => {
    const data ={orderId}
try {
  const response = await axios.post('https://api.trucoo.in/invoice/order-details/',data,  {
    headers: {
      'Content-Type': 'application/json',
      'X-API-KEY': 'erpTrucoo'
    }
  });
  console.log(response.data);
  if(response.data.status === 'success'){
    setInvoiceData(response.data.data);
    setClientData(response.data.data[0].clientData);
    setOrderItems(response.data.data[0].orderData);
  }
} catch (error) {
  console.error("Error:", error.response || error.message);
}
};
useEffect(() => {
    getInvoice();
  },[]);

    const companyData = [{
        companyName: "TRUCOO DAIRY PRODUCTS PRIVATE LIMITED",
        companyAddress1: "C202, SK Hill view Apartment",
        companyAddress2: "Rainbow Enclave, Sugunapuram Mylkal",
        companyLocation: "Sugunapuram Mylkal",
        companyCity: "Coimbatore",
        companyState: "Tamil Nadu",
        companyZip: "641008",
        companyPhone: "+91 81900 03400",
        companyEmail: "sales@trucoo.in",
        companyGst: "GSTIN: 33AAMCS4120LEEE",
        ts: "Sample Terms and Conditions"
    }];   

    
    const cGst = 1;
    const sGst = 1;

    
const calculateDiscount = () => {
    
    
    let discount = 0;
    let Totalgrade=2; 

    
    if (selectedButton === "liters") {
      const liters = parseFloat(input);
      if (!isNaN(liters)) {
        discount=liters * totalliters;
        setDiscount(discount); 
        
      } else {
        alert("Please enter a valid number for liters.");
      }
    } else if (selectedButton === "percent") {
      const percent = parseFloat(input);
      if (!isNaN(percent)) {
        const discount = (totalAmount * percent) / 100;
        setDiscount(discount);
         
      } else {
        alert("Please enter a valid number for percentage.");
      }
    }
    else if (selectedButton === "grade") {
      const grade = parseFloat(input);
      if (!isNaN(grade)) {
        const discount = (totalliters / 12) * grade;
        setDiscount(discount);
         
      } else {
        alert("Please enter a valid number for grade.");
      }
    }
    
  };

  const downloadPDF = () => {
    const invoiceElement = document.getElementById("printableArea");

    html2canvas(invoiceElement, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("invoice.pdf");
    });
  };

  const totalAmount = orderItems.reduce((total, item) => 
    total + (Number(item.subtotal) + 
             (item.price * item.qty * cGst) / 100 + 
             (item.price * item.qty * sGst) / 100), 
    0);

  const totalliters=orderItems.reduce((total, item) => total + Number(item.qty), 0);

  const totalAmountInWords = numberToWords.toWords(Number(Math.round(totalAmount-discount)).toFixed(2));

// const totalAmount=1;
// const totalliters=1;




    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                  <section class="content">
                    <div class="box">
                      <div class="box-header with-border">
                        <h4 class="box-title">Invoice</h4>
                        <p class="mb-0 box-subtitle">{orderId}</p>
                      </div>
                      <div class="box-body">
                        <div class="row" >
                        <h1 className="text-2xl font-bold text-gray-900 mb-6 text-center">Discount</h1>
                          <div class="col-lg-4 mt-4">
                              <select className="form-select" onChange={(e) => handleButtonClick(e.target.value)}>
                                <option>Select Options</option>
                                <option value="liters">Littres</option>
                                <option value="percent">Percentage</option>
                                <option value="grade">Grade</option>
                              </select>
                              <input type="text" name="input" value={input} className="form-control mt-3" placeholder="Enter Input" onChange={handleInputChange}/>
                              <div class="row" >
                                <div class="col-lg-6">
                                  <button className="btn btn-success mt-4" onClick={calculateDiscount}>Apply Discount</button>  
                                </div>
                                <div class="col-lg-6 mt-2">
                                  <h3 class="mt-4">Discount : {discount.toFixed(2)}</h3> 
                                </div>
                              </div>
                          </div>
                          <div class="col-lg-8 mt-4" align="right">
                              <button className='btn btn-success mt-4' onClick={downloadPDF}>Download Invoice</button>
                          </div>
                        </div>
                      </div>
                      </div>
                    </section>

                    <section className="invoice" id="printableArea" style={{ maxWidth: '100%', padding: '20mm', boxSizing: 'border-box', border: '1px solid #ccc', justifyContent: 'center' }}>
                        <div className="row align-items-center justify-content-md-center h-p100">

                        <div className="col-sm-7 text-fade">
                                <h6 className="text-left">{companyData && companyData[0]?.companyName}</h6>
                                <address className="text-left">
                                    {companyData && companyData[0]?.companyAddress1}, {companyData && companyData[0]?.companyAddress2}
                                    <br></br>
                                    {companyData && companyData[0]?.companyLocation}, {companyData && companyData[0]?.companyCity},
                                    {companyData && companyData[0]?.companyState} - {companyData && companyData[0]?.companyZip} <br />
                                    Ph: {companyData && companyData[0]?.companyPhone}<br />
                                    {companyData && companyData[0]?.companyGst}<br />
                                </address>
                            </div>
                            <div className="col-sm-5 d-flex justify-content-end">
                               <img src={Qr} alt="QR Code" width="200px" />
                            </div>


                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="text-center" colSpan="2">Tax Invoice</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-dark">
                                                <address >
                                                    <p className="text-dark">Billing Address</p>
                                                    {clientData.companyName}<br />
                                                    {clientData.companyAddress}<br />
                                                    {clientData.companyEmail}<br />
                                                    {clientData.companyContact}<br />
                                                    GST: &nbsp;&nbsp;&nbsp;{clientData.gst}
                                                </address>
                                            </td>
                                            <td className="text-dark">
                                              <address >
                                                    <p className="text-dark">Shipping Address</p>
                                                    {clientData.companyName}<br />
                                                    {clientData.companyAddress}<br />
                                                    {clientData.companyEmail}<br />
                                                    {clientData.companyContact}<br />
                                                    GST: &nbsp;&nbsp;&nbsp;{clientData.gst}
                                                </address>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="table-responsive ">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className="fs-10 fw-600 text-dark">
                                            <th rowSpan={2}>S No</th>
                                            <th rowSpan={2}>PARTICULARS</th>
                                            <th rowSpan={2}>UNIT</th>
                                            <th rowSpan={2}>GRADES</th>
                                            <th rowSpan={2}>QTY</th>
                                            <th rowSpan={2}>LTR</th>
                                            <th rowSpan={2}>RATE</th>
                                            <th rowSpan={2}>AMOUNT</th>
                                            <th colSpan={2}>CGST</th>   
                                            <th colSpan={2}>SGST Rate (%)</th>
                                            <th rowSpan={2}>Total Amount</th>
                                        </tr>
                                        <tr className="fs-10 fw-800 text-dark">
                                          <th>Rate (%) </th>
                                          <th>Value </th>
                                          <th>Rate (%) </th>
                                          <th>Value </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderItems.map((item, index) => {
                                          const itemPrice = item.price;
                                          const itemQty = item.qty;
                                          const itemSubtotal = item.subtotal;
                                          const cgstTotal = (itemPrice * itemQty * cGst) / 100;
                                          const sgstTotal = (itemPrice * itemQty * sGst) / 100;
                                          const totalAmount = Number(itemSubtotal) + cgstTotal + sgstTotal;

                                          const grade = Math.ceil((itemQty / 12))
                                          return(
                                            <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                <td>{index + 1}</td> 
                                                <td class="text-left">{item.Item}</td>
                                                <td>LTR</td>
                                                <td>{grade}</td>
                                                <td>{item.qty}</td>
                                                <td>{grade}</td>
                                                <td>{Number(item.price).toFixed(2)}</td>
                                                <td>{Number(item.subtotal).toFixed(2)}</td>
                                                <td >{Number(cGst).toFixed(0)}%</td>
                                                <td>{Number(cgstTotal).toFixed(2)}</td>
                                                <td> {Number(sGst).toFixed(0)}%</td>
                                                <td>{Number(sgstTotal).toFixed(2)}</td>
                                                <td class="text-end">{Number(totalAmount).toFixed(2)}</td>

                                                                                                
                                            </tr>);
                                           })}
                                       
                                        <tr>
                                            <td className="text-left" colSpan="2"><p>Our Bank Details</p>
                                            <span>AC/NO:910020049921708</span> <br />
                                            <span>IFSC CODE:UTIB0001206</span> <br />
                                            <span>BANK:AXIS BANK</span><br />
                                            <span>BRANCH:VALAPADY</span><br />
                                            </td>
                                            <td>TOTAL</td>
                                            <td></td>
                                            <td>{totalliters}</td>
                                            <td></td>
                                            <td></td>
                                            <td>{Number(orderItems.reduce((total, item) => total + Number(item.subtotal), 0)).toFixed(2)}</td>
                                            <td></td>
                                            <td>{Number(orderItems.reduce((total, item) => total + (item.price * item.qty * cGst) / 100, 0)).toFixed(2)}</td>

                                            <td></td>
                                            <td>{Number(orderItems.reduce((total, item) => total + (item.price * item.qty * sGst) / 100, 0)).toFixed(2)}</td>

                                            <td class="text-end">{Number(totalAmount).toFixed(2)}</td>

   
                                        </tr>
                                        <tr>
                                            <td  className="text-left" colSpan="3"> We request you to make the payment through our UPI ID:
                                                <br/>SKSDAIRY@AXISBANK
                                            </td>
                                            <td className="text-left" colSpan="7">
                                                <p>Remarks:</p>
                                                INSURANCE UNDER BUYERS SCOPE:<br/>
                                                <span>Delivery call :9344773757</span>
                                            </td>
                                            <td className="text-left" colSpan="2">Discount:</td>
                                            <td class="text-end">{Number(discount).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="10">Electronic Referance Number:</td>
                                            <td className="text-left" colSpan="2">BILL AMOUNT:</td>
                                            <td class="text-end">{Number(totalAmount-discount).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="10"></td>
                                            <td className="text-left" colSpan="2">ROUND AMOUNT:</td>
                                            <td class="text-end">{Number(Math.round(totalAmount-discount)).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="13">
                                            <p>Payable Amount In words : {totalAmountInWords.toUpperCase()} RUPEES ONLY</p>
                                                

                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="5">E&OE</td>
                                            <td className="text-center" colSpan="9">SKA DAIRY FOODS INDIA (P) LTD</td>
                                        </tr>
                                        <tr>
                                          <td className="text-left" ><br/>Received By</td>
                                          <td className="text-left" colSpan="4"> <br/>Prepared By</td>
                                          <td className="text-left" colSpan="4"> <br/>Charge</td>
                                          <td className="text-left" colSpan="4"> <br/>Authorized Signature</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>                                           

                        </div>
                    </section>
                    
                </div>
                


            </div>
            

            <Footer />
        </>
    );
}

export default InvoicePage;
